import React, { Component } from 'react';
import './index.css';
import { useNavigate } from "react-router-dom";
import { errorCatch, LanguageContext, MetaContext, POST, QueryDetail, READWITH, TranslateContext, useAuth, UserConfigContext, UserContext } from 'fennec-ui';
// or 'antd/dist/antd.less'
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { LangSwitchContext, TranslatesContext, useLayoutWidthContext } from '../../../components/Context';
import { useState } from 'react';
import { translate } from '../../../components/Tool';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import LangSwitch from '../../../components/LangSwitch';
import { useEffect } from 'react';
import { Layout } from 'antd';
import FedHeader from '../FedHeader';
import { Content } from 'antd/es/layout/layout';
import { useTranslation } from 'react-i18next';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
var _ = require('lodash');
dayjs.locale('ru');

//https://www.youtube.com/watch?v=hjp-JHVsgxQ
//https://github.com/pantharshit00/jwt-react-auth
//https://hptechblogs.com/using-json-web-token-react/
//https://github.com/pantharshit00/jwtAuth

function String({ value, onChange, prefix, placeholder }) {
  return (
    <Input allowClear value={value} prefix={prefix} placeholder={placeholder} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function Login(props) {
  let navigate = useNavigate();
  const auth = useAuth();
  const dispatch = useDispatch();

  const { t } = useTranslation()

  const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();

  const [userConfig, _setUserConfig] = useState({});
  const [translates, setTranslates] = useState();

  const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
  // const t = React.useMemo(() => _.bind(translate, {
  //   translate: translates,
  //   config: language
  // }), [translates, language]);
  // const t = useTranslateContext();

  const handleSubmit = (values) => {
    auth.login(values.username, values.password).then(res => {
      if (!res.status) {
        message.error(res.message);
      }
    })
  };

  var nurl = new URL(window.location.href);
  var refUrl = nurl.searchParams.get("service");

  useEffect(() => {
    READWITH(auth, 'Translate', [
      QueryDetail("model")
    ], ({ data }) => {
      if (data.length > 0) {
        let o = Object.fromEntries(data.map(i => {
          return [
            i.key,
            {
              ru: i.ru,
              en: i.en,
              es: i.es,
              tr: i.tr,
            },
          ]
        }));
        // dispatch(REDUX_Translate.actions.setObject(o));
        setTranslates(o)
      }
    }, errorCatch)
  }, [auth]);

  // //Чистим куки token при открытии формы логин. Возможны грабли.
  // window.document.cookie = 'token=; Max-Age=0; path=/; domain=' + auth.getDomainWithoutSubdomain(window.location.href);
  return (
    <TranslatesContext.Provider value={translates}>
      <TranslateContext.Provider value={t}>
        <LanguageContext.Provider value={[language, setLanguage]}>
          <LangSwitchContext.Provider value={<LangSwitch />}>
            <Layout>
              <FedHeader layout={"web"} hideLogo={true}>
                {/* <MenuOne menu={menu(status, notify)} /> */}
              </FedHeader>
              <Content style={{ padding: '6px', backgroundColor: "white" }}>
                <div className="login-form">
                  <div style={{ textAlign: "center" }}>
                    <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
                      <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
                    </a>
                  </div>

                  <Form name="normal_login" onFinish={handleSubmit} className="login-form">
                    <Form.Item
                      name="username"
                      rules={[{ required: true, message: t('login.Пожалуйста, введите адрес электронной почты!') }]}
                    >
                      <String
                        prefix={<UserOutlined />}
                        placeholder={t("login.Адрес электронной почты")}
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[{ required: true, message: t('login.Пожалуйста, введите пароль!') }]}
                    >
                      <Input.Password
                        prefix={<LockOutlined />}
                        iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        // type="password"
                        placeholder={t("login.Пароль")}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" className="login-form-button">
                        {t("login.Войти")}
                      </Button>
                    </Form.Item>
                  </Form>
                  <div>
                    <div style={{ padding: "15px 0" }}>
                      <div className='line'><span>{t("login.или")}</span></div>
                    </div>
                    <Button style={{ width: "100%" }} href={(refUrl) ? "/signup?service=" + refUrl : "/signup"} type="default">
                      {t("login.Зарегистрироваться")}!
                    </Button>
                    <div style={{ padding: "15px 0" }}>
                      <Button style={{ width: "100%" }} href='/forgot-password' type="ghost">
                        {t("login.Забыли пароль")}?
                      </Button>
                    </div>
                  </div>
                </div>
              </Content>
            </Layout>
          </LangSwitchContext.Provider>
        </LanguageContext.Provider>
      </TranslateContext.Provider>
    </TranslatesContext.Provider >
  );
}

// const Login = Form.create({ name: 'normal_login' })(NormalLoginForm);
export default Login;